
import Funcs from "@/functions";

const cdnStuffPlugin = {
  install(Vue, options) {

    Vue.prototype.$urlOrDefault = (url, type) => {

      if(url === null || url === ""){
        switch(type){
          case 'logo':
            url=Funcs.getImageUrl('uploads/default/default_logo.png');
            break;
          case 'event-cover':
            url=Funcs.getImageUrl('uploads/default/default_event_cover.jpg');
            break;
        }


      } else {

      }

      return url;

    }
  	Vue.mixin({
      mounted() {
      },
    })
  },
}

export default cdnStuffPlugin
